<template>
  <div :class="$style.falling" data-loader-v="3.0.1">
    <ScreenReaderOnly>Loading...</ScreenReaderOnly>
    <span :class="[$style.dot, $style.before]" />
    <span :class="$style.dot" />
    <span :class="[$style.dot, $style.after]" />
  </div>
</template>

<style lang="scss" module>
.falling {
  display: inline-block;
}

.dot {
  background-color: var(--loader-color, #504e8b);

  display: inline-block;

  border-radius: var(--loader-dot-border-radius, 50%);
  height: var(--loader-dot-size, 10px);
  width: var(--loader-dot-size, 10px);

  margin: var(--loader-dot-margin, 0 2px);

  animation: dot-falling 1s infinite linear;
  animation-delay: 0.1s;

  &.before {
    animation-delay: 0s;
  }

  &.after {
    animation-delay: 0.2s;
  }
}

@keyframes dot-falling {
  0% {
    opacity: 0;
    transform: translateY(-15px);
  }
  25%,
  50%,
  75% {
    opacity: 1;
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    transform: translateY(15px);
  }
}
</style>
